// components/CoreRatios.jsx
export default function CoreRatios({ company, ratios }) {
  const { pe, pb, currentRatio, debtRatio, debtToEquity } = ratios;

  return (
    <p className="mb-5">
      When analysing {company}, valuation and balance sheet ratios such as the Price to Earnings (PE) ratio, Price to Book (P/B) ratio, Current Ratio, Debt Ratio, and Debt to Equity ratio provide insight into how the company is valued and financed. {company} has {pe && <>a PE ratio of <strong>{pe}</strong>,</>} {pb && <>a P/B ratio of <strong>{pb}</strong>,</>} {currentRatio && <>a current ratio of <strong>{currentRatio}</strong>,</>} {debtRatio && <>a debt ratio of <strong>{debtRatio}</strong>,</>} {debtToEquity && <>and a debt to equity ratio of <strong>{debtToEquity}</strong></>}.
    </p>
  );
}
